module.exports = __webpack_public_path__ + "static/media/maze.a7a479cc.png";